import { addressFinderSchema } from '@eneco/components/AddressFinder/AddressFinder';
import * as yup from 'yup';

export const createFormSchema = (isSuffixRequired: boolean) =>
  yup.object({
    ...addressFinderSchema(isSuffixRequired).fields,
  });
